import { AdminRouter, AdminSidebar } from 'stylemix-vue-admin'
import { messageGroups } from '../../../../../console/src/plugins/i18n'

const base = 'respond_io'

/*
AdminRouter.addRoute({
  name: `${base}`,
  path: `/${base}`,
  component: () => import('./Synchronization.vue'),
  meta: {
    auth: true,
  },
});

AdminSidebar.pushItem({
  id: `${base}`,
  order: 150,
  header: $vm => $vm.$t(`general.menu_management`),
  text($vm) {
    return $vm.$t(`${base}.title`)
  },
  route: {
    name: `${base}`,
  },
  icon: 'icon-checkmark5',
  permission($vm) {
    return $vm.$allows('users.index') || $vm.$allows('users.serve')
  },
  children: [
    {
      id: `${base}-synchronization`,
      text: ($vm) => $vm.$t(`settings.sections.respond_io_sync`),
      icon: 'icon-sync',
      route: {
        name: `${base}-synchronization`,
      },
    },
    {
      id: `${base}-field-mapping`,
      text: ($vm) => $vm.$t(`settings.sections.respond_io_fields`),
      icon: 'icon-map5',
      route: {
        name: `${base}-field-mapping`,
      },
    },
    {
      id: `${base}-settings`,
      text: ($vm) => $vm.$t(`settings.sections.respond_io_api`),
      icon: 'icon-opt',
      route: {
        name: `${base}-settings`,
      },
    },
  ],
})
*/
messageGroups.push(base)
